import * as React from 'react'
import * as clsx from 'clsx'

interface Props {
  children: React.ReactNode
  className?: string
  circleClassName?: string
}

export const CircleCheck = ({ children, className, circleClassName }: Props): JSX.Element => (
  <div className={className}>
    <div className="d-inline-flex align-items-center mt-1">
      <div className={clsx('me-2 circle-check align-self-start', circleClassName)}>
        <i className="uil-check text-white font-size-xxl" />
      </div>
      <div className="lh-initial">{children}</div>
    </div>
  </div>
)
